import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { backendUrl } from '@jdiyield/constants';
import { api } from '@jdiyield/utils';

var getNetWorthHistory = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(account) {
    var day,
        result,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            day = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
            _context.prev = 1;
            _context.next = 4;
            return api.get("".concat(backendUrl, "/net-worth/history/").concat(account, "?days=").concat(day));

          case 4:
            result = _context.sent;
            return _context.abrupt("return", result.data);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", {});

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function getNetWorthHistory(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default getNetWorthHistory;